import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "@cakrawalajakarta/shared-components";

export const QRISMedicPayment = () => {
  const { showNotification } = useNotification();
  const [qrData, setQrData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const generateQRIS = async () => {
    setLoading(true);
    setErrorMsg("");
    setSuccessMsg("");

    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_BASE_URL}/api/generate-qris-medic`,
        {
          eventId: "JOTR",
          harga: 25000,
        }
      );

      console.log("[INFO] QRISMedicPayment: QRIS generated successfully", {
        orderId: response.data.orderId,
        qrUrl: response.data.qrUrl,
      });

      setQrData({
        orderId: response.data.orderId,
        qrUrl: response.data.qrUrl,
        harga: 25000,
      });
      setSuccessMsg("QRIS berhasil dibuat! Silakan scan untuk membayar.");
      showNotification("success", "QRIS berhasil dibuat!");
    } catch (error) {
      let errorMessage = "Gagal membuat QRIS. Silakan coba lagi.";
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }
      console.error("[ERROR] QRISMedicPayment: Failed to generate QRIS", {
        error: error.message,
        response: error.response?.data,
      });
      setErrorMsg(errorMessage);
      showNotification("error", errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("[INFO] QRISMedicPayment: Component mounted, generating QRIS");
    generateQRIS();
  }, []);

  const handleNewQR = () => {
    console.log("[INFO] QRISMedicPayment: Generating new QRIS");
    setQrData(null);
    setErrorMsg("");
    setSuccessMsg("");
    generateQRIS();
  };

  return (
    <div className="min-h-screen bg-white shadow-xl px-4 sm:px-6 lg:px-8 z-0">
      <div className="max-w-3xl mx-auto py-20">
        <h2 className="text-2xl font-semibold text-left mb-4">
          Pembayaran Cek Kesehatan - QRIS
        </h2>
        <div className="bg-white p-4 rounded-xl border border-slate-200 backdrop-blur-md">
          {loading ? (
            <div className="flex justify-center items-center">
              <p className="text-lg text-slate-800">Memuat QRIS...</p>
            </div>
          ) : qrData ? (
            <div className="flex flex-col items-center gap-4">
              <h3 className="text-lg font-medium text-slate-800">
                Scan QRIS untuk Pembayaran
              </h3>
              <p className="text-sm text-slate-600">
                Order ID: <strong>{qrData.orderId}</strong>
              </p>
              <p className="text-sm text-slate-600">
                Harga: <strong>Rp {qrData.harga.toLocaleString()}</strong>
              </p>
              <img
                src={qrData.qrUrl}
                alt="QRIS Code"
                className="max-w-xs w-full"
              />
              {(errorMsg || successMsg) && (
                <p
                  className={`text-center font-medium ${
                    errorMsg ? "text-rose-600" : "text-slate-800"
                  }`}
                >
                  {errorMsg || successMsg}
                </p>
              )}
              <Button
                onClick={handleNewQR}
                variant="primary"
                className="w-full max-w-xs uppercase"
                disabled={loading}
              >
                {loading ? "Loading..." : "Generate QRIS Baru"}
              </Button>
            </div>
          ) : (
            <div className="flex flex-col items-center gap-4">
              <p className="text-lg text-rose-600">
                Gagal memuat QRIS: {errorMsg || "Silakan coba lagi."}
              </p>
              <Button
                onClick={handleNewQR}
                variant="primary"
                className="w-full max-w-xs uppercase"
                disabled={loading}
              >
                {loading ? "Loading..." : "Coba Lagi"}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
